import React from 'react'
import './styles.scss'
const InvisibleInput = () => {
    return <input className="invisible-input" readOnly/>
}

export default InvisibleInput